module.exports = __webpack_public_path__ + "89b53a5b6ea737eb59033c90e96d3b5e.png";